/** Ressources déjà branchées sur RemoteRepositoriesAdapter. */
export const CORE_REMOTE_RESOURCES = [
  'salaries',
  'bulletins',
  'ecritures',
  'factures',
  'centres-analytiques',
] as const;

/**
 * Anciennes familles « extended » : pas d’endpoint /v1/{resource} côté business-api.
 * Elles vivent dans MODULE_DATA_REMOTE_NAMESPACES (conges → rh.conges, immos, stocks…).
 * Conservé vide pour ne plus hydrater des 404 fantômes.
 */
export const EXTENDED_REMOTE_RESOURCES = [] as const;

/**
 * Tous les namespaces métier connus. En Cloud, le dossier entier part chez Nexxus
 * (liste API + ces clés + tout namespace local non technique).
 */
export const MODULE_DATA_REMOTE_NAMESPACES = [
  'coffrefort',
  'stocks',
  'tiers',
  'exercices',
  'immobilisations',
  'immobilisations_comptables',
  'rh.conges',
  'rh.sanctions',
  'rh.suspensions',
  'rh.evaluations',
  'rh.offres',
  'rh.candidatures',
  'rh.notes_frais',
  'rh.vehicules',
  'rh.engagements_financiers',
  'rh.stc_config',
  'rh.convention_key',
  'rh.anciennete_config',
  'rgpd.dpo',
  'rgpd.traitements',
  'rgpd.demandes',
  'viesociale.ag',
  'viesociale.conventions',
  'viesociale.distributions',
  'viesociale.rapport',
  'viesociale.ri',
  'legal.privacy_policies',
  'legal.data_consents',
  'reglements',
  'tva_credits',
  'inventaires',
  'devises',
  'tiers_institutionnels',
  'conformite.profil',
  'conformite.patente',
  'conformite.systeme',
  'compta.plan',
  'compta.periodes_cloturees',
  'fiscalite.dts',
] as const;

/** Namespaces périodiques (saisie paie, sceau comptable). */
export const MODULE_DATA_DYNAMIC_PREFIXES = ['paie.saisie.', 'compta.sceau.'] as const;

const TECHNICAL_NAMESPACES = new Set(['sync.conflict', 'device_label']);

export const ALL_REMOTE_RESOURCES = [
  ...CORE_REMOTE_RESOURCES,
  ...EXTENDED_REMOTE_RESOURCES,
] as const;

export function isDossierNamespace(namespace: string): boolean {
  if (!namespace || TECHNICAL_NAMESPACES.has(namespace)) return false;
  if (namespace.startsWith('sync.')) return false;
  return true;
}

export function collectDossierNamespaces(...groups: readonly (readonly string[])[]): string[] {
  const set = new Set<string>(MODULE_DATA_REMOTE_NAMESPACES);
  for (const group of groups) {
    for (const ns of group) {
      if (isDossierNamespace(ns)) set.add(ns);
    }
  }
  return [...set].sort();
}

export function hasMeaningfulDossierValue(value: unknown): boolean {
  if (value == null) return false;
  if (typeof value === 'string') return value.trim().length > 0;
  if (typeof value === 'number') return true;
  if (typeof value === 'boolean') return true;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object') {
    const rec = value as Record<string, unknown>;
    if (Array.isArray(rec.items)) return rec.items.length > 0;
    if ('value' in rec && Object.keys(rec).length === 1) {
      return hasMeaningfulDossierValue(rec.value);
    }
    return Object.keys(rec).length > 0;
  }
  return false;
}
